import Service from "../../AuthService";
const factoryEmployee = {
    getFactoryEmployee(page,data){
        return Service.get(`/factory_employee?page=${page}`+
            `&factory_id=${data.factory_id}`
        );
    },
    showFactoryEmployee(id){
        return Service.get('/factory_employee/'+id);
    },
    createFactoryEmployee(data){
        return Service.post('/factory_employee',data);
    },
    updateFactoryEmployee(id,data){
        return Service.put('/factory_employee/'+id,data);
    },
    deleteFactoryEmployee(id){
        return Service.delete('/factory_employee/'+id);
    },
    getAllFactoryEmployee(){
        return Service.get('/factory_employee_all');
    },
}
export default factoryEmployee
